export default __webpack_public_path__ + "static/media/saleout_banner.119ecc4b.png";